import React from "react";
import { TopHeading, Wrapper } from "../../../common/index.style";
import { Col, Row, Card } from "antd";
import { Link } from "react-router-dom";
import {
  TeamOutlined,
  UserAddOutlined,
  TransactionOutlined,
  DollarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const links = [
  {
    title: "Publishers",
    description: "View and manage all publishers",
    address: "/publisher",
    icon: <TeamOutlined style={{ fontSize: 28, color: "#4a6fa5" }} />,
  },
  {
    title: "Add Publisher",
    description: "Onboard a new publisher",
    address: "/publisher/add",
    icon: <UserAddOutlined style={{ fontSize: 28, color: "#4a6fa5" }} />,
  },
  {
    title: "Transactions",
    description: "View all article transactions",
    address: "/transaction",
    icon: <TransactionOutlined style={{ fontSize: 28, color: "#4a6fa5" }} />,
  },
  {
    title: "Settlements",
    description: "Manage publisher settlements",
    address: "/settlement",
    icon: <DollarOutlined style={{ fontSize: 28, color: "#4a6fa5" }} />,
  },
  {
    title: "Onboarding Requests",
    description: "Review pending requests",
    address: "/onboarding-requests",
    icon: <FileTextOutlined style={{ fontSize: 28, color: "#4a6fa5" }} />,
  },
];

const Home = () => {
  return (
    <Wrapper>
      <TopHeading>Dashboard</TopHeading>
      <Row gutter={[24, 24]}>
        {links.map((item, i) => (
          <Col xs={24} sm={12} lg={8} key={i}>
            <Link to={item.address} style={{ display: "block" }}>
              <Card
                hoverable
                style={{ height: "100%" }}
                styles={{ body: { padding: "24px" } }}
              >
                <div style={{ marginBottom: 12 }}>{item.icon}</div>
                <Card.Meta
                  title={
                    <span style={{ fontSize: 16, fontWeight: 600 }}>
                      {item.title}
                    </span>
                  }
                  description={item.description}
                />
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Wrapper>
  );
};

export default Home;
